const locale: Locale = {
  ko: {
    capslock: 'Caps Lock이 켜져있습니다.',
    check: '이메일 혹은 비밀번호를 확인해주세요.',
    signin: '로그인',
    email: '지스트 이메일을 입력하세요',
    password: '비밀번호를 입력하세요',
    confirmPwd: '비밀번호를 재입력하세요',

    forgotPwd: '비밀번호를 잊으셨나요?',
    signupMsg: '계정이 없으신가요?',

    already: '이미 가입하셨나요?',

    signup: '회원가입',

    useGistEmail: '지스트 이메일을 사용해주세요.',
    codeSent: '으로 인증코드가 전송되었습니다.',
    notCode: '존재하지 않는 인증 코드 입니다.',
    expiredCode: '만료된 인증 코드 입니다.',

    diffPwd: '비밀번호가 일치하지 않습니다.',
    formatPwd: '영문과 숫자를 포함한 8자리 이상의 비밀번호를 설정해주세요',

    nextBtn: '다음 단계',
    codeBtn: '인증코드 전송',
    reCodeBtn: '인증코드 재전송',
    verifyBtn: '인증',
    reVerifyBtn: '재인증',

    success: '성공!',
    registered: '회원가입이 완료되었습니다.',
  },
  en: {
    capslock: 'Caps Lock is On.',
    check: 'Please check your details and try again.',
    signin: 'Sign In',
    email: 'GIST email',
    password: 'password',
    confirmPwd: 'confirm password',

    forgotPwd: 'Forgot password?',
    signupMsg: "Don't have an account?",

    signup: 'Sign Up',
    already: 'Already a member?',

    useGistEmail: "Enter your 'GIST' email.",
    codeSent: ' - Verification code has been sent.',
    notCode: 'The verification code is not correct. Try again.',
    expiredCode: 'Verification code was expired',
    diffPwd: 'Passwords do not match.',
    formatPwd:
      'Password must be at least 8 characters and contain both numbers and letters.',

    nextBtn: 'Next',
    codeBtn: 'Send Verification Code',
    reCodeBtn: 'Resend Verification Code',
    verifyBtn: 'Verify',
    reVerifyBtn: 'Re-verify',

    success: 'Success!',
    registered: 'Sign up is complete.',
  },
}

export default locale
